// 运行时配置
// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate
import { message } from 'antd'
import { Location } from 'history'
import { isUndefined, pickBy } from 'lodash'
import type { RequestConfig } from 'umi'
import { IRoute, createBrowserHistory, matchRoutes, useModel } from 'umi'

/**
 * 路由变化时修改标题
 */
export async function onRouteChange({ clientRoutes, location }: { clientRoutes: IRoute[]; location: Location }) {
	const route: any = matchRoutes(clientRoutes, location.pathname)?.pop()?.route
	if (route) {
		document.title = route.title || ''
	}
}

/**
 * 数据请求配置
 */
export const request: RequestConfig = {
	timeout: 60000,
	headers: { 'Content-Type': 'application/json' },
	requestInterceptors: [
		(url, options) => {
			// 是否为简单表单请求
			if (options.isFormUrlencoded) {
				options.headers = {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
					Accept: 'application/json,text/javascript',
				}
				options.data = new URLSearchParams(pickBy(options.params, (val) => !isUndefined(val))).toString()
				delete options.params
			}
			// 是否为表单请求
			if (options.isFormData) {
				options.headers = {
					'Content-Type': 'multipart/form-data',
				}
				const formData = new FormData()
				for (const key in options.params) {
					if (options.params[key] !== undefined) {
						formData.append(key, options.params[key])
					}
				}
				options.data = formData
				delete options.params
			}
			return { url, options }
		},
	],
	responseInterceptors: [
		[
			(response: any) => {
				const { data = {}, config } = response
				// 直接返回 response，不再处理异常
				if (config.passResponseHandler) {
					return response
				}
				// 会话过期
				if (data.res === 302) {
					window.location.href = '/'
					return
				}
				// 统一错误提示
				if (data.res !== 200) {
					message.error(data.errmsg)
					return Promise.reject(data)
				}
				return response
			},
			(error: any) => {
				message.error(error.message || error)
				return Promise.reject(error)
			},
		],
	],
}
/**
 * qiankun 子应用配置
 *
 */
export function useQiankunStateForSlave(): {
	BaseRouter: any
	OMSData: any
	isInitLoadSuccess: boolean
	isBackEnd: boolean
	callParentComponent: (params: { componentName: never; props: any; containerDom: Element }) => void
} {
	const { callParentComponent, userInfo, isInitLoadSuccess = false } = useModel('global')
	//基座的common数据传递给子应用
	const x = createBrowserHistory()
	return {
		BaseRouter: x,
		OMSData: userInfo,
		isInitLoadSuccess,
		isBackEnd: true,
		callParentComponent,
	}
}
export const qiankun = async () => {
	const originPath = `${location.pathname}${location.search}`
	const PublicDomain: Record<string, string> = {
		pre: 'public-preop.netease.im',
		prod: 'public-oms.netease.im',
	}
	const HOST_ENV = process.env.HOST_ENV || ''
	// 预发与线上 公共应用地址
	const onlinePublicUrl = `${location.protocol}//${PublicDomain[HOST_ENV]}/`
	// 本地与测试环境地址 回归环境
	const testPublicUrl = process.env.public_host || location.origin.replace('op.', 'public-op.') + '/'
	const publicUrl = ['pre', 'prod'].includes(HOST_ENV) ? onlinePublicUrl : testPublicUrl
	return {
		/**
		 * 老应用中部分路由请求错误时，会返回json类型数据，导致qiankun报错
		 * 通过重写fetch方法，将json类型数据转换为html类型数据，解决qiankun报错问题
		 * 处理子应用路由请求失败返回json类型数据的情况
		 */
		fetch: (url: RequestInfo | URL, ...args: [init?: RequestInit | undefined]) => {
			return window.fetch(url, ...args).then(async (response) => {
				// 读取响应流并处理
				const clonedResponse = response.clone()
				const contentType = response.headers.get('Content-Type')

				let result: any = clonedResponse.body
				let headers: any = clonedResponse.headers
				if (contentType?.includes('application/json')) {
					const data = await response.json()
					result = `<html>
						<head><title>error</title></head><body>
						<center><div>${JSON.stringify(data)}</div></center>
						</body><script>
						(function (global) {global['purehtml'] = {
							bootstrap: function () {return Promise.resolve()},
							mount: function (props) {props.setLoading(false);return Promise.resolve()},
							unmount: function() {return Promise.resolve()}}
						})(window)</script></html>
					`
					headers['Content-Type'] = 'text/html;charset=UTF-8'
				}
				// 重新发送原始响应流
				return new Response(result, {
					status: clonedResponse.status,
					statusText: clonedResponse.statusText,
					headers: headers,
				})
			})
		},
		apps: [
			{
				name: 'public',
				entry: publicUrl,
			},
			{
				name: 'oldApp',
				entry: `/backEndRouter${originPath}`,
				credentials: true,
			},
		],
	}
}
